import { render, staticRenderFns } from "./veStuAssocInfo.vue?vue&type=template&id=9fc4dd28&scoped=true"
import script from "./veStuAssocInfo.vue?vue&type=script&lang=js"
export * from "./veStuAssocInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc4dd28",
  null
  
)

export default component.exports